export default __webpack_public_path__ + "static/Home page creative  v1-68a1b3010502ae3adfe3cf4560614760.jpg";